import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import "../styles/footer.css";

const Footer = () => {
  const location = useLocation();
  const { t } = useTranslation(); // Hook de traducción
  const isActive = (path) => location.pathname === path;
  const currentYear = new Date().getFullYear();

  // Estados para controlar la orientación y expansión
  const [isPortrait, setIsPortrait] = useState(window.innerHeight > window.innerWidth);
  const [isExpanded, setIsExpanded] = useState(false);

  // Detectar cambios de orientación
  useEffect(() => {
    const handleResize = () => {
      const portrait = window.innerHeight > window.innerWidth;
      setIsPortrait(portrait);
      // Colapsar automáticamente al rotar a horizontal
      if (!portrait) setIsExpanded(false);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Manejar la expansión/colapso en modo vertical
  const handleToggle = () => {
    if (isPortrait) {
      setIsExpanded(!isExpanded);
    }
  };

  // Manejar clic en enlaces (colapsar después de elegir)
  const handleLinkClick = () => {
    if (isPortrait) {
      setIsExpanded(false);
    }
  };

  // Clases condicionales para el footer
  const footerClass = `footer ${isPortrait ? 'portrait' : 'landscape'} ${isExpanded ? 'expanded' : 'collapsed'}`;

  return (
    <footer className={footerClass}>
      <div className="footer-content">
        {isPortrait ? (
          // Versión vertical retráctil - Sin copyright
          <div className="footer-links" onClick={handleToggle}>
            {isExpanded ? (
              // Mostrar todos los enlaces en modo expandido (sin copyright)
              <>
                <div className="footer-item">
                  <Link 
                    to="/terms" 
                    className={isActive('/terms') ? 'active' : ''}
                    onClick={handleLinkClick}
                  >
                    {t('footer.terms')}
                  </Link>
                </div>
                <div className="footer-item">
                  <Link 
                    to="/fwb" 
                    className={isActive('/fwb') ? 'active' : ''}
                    onClick={handleLinkClick}
                  >
                    {t('footer.fwb', 'Amigos con Beneficios')}
                  </Link>
                </div>
                <div className="footer-item">
                  <Link 
                    to="/privacy-policy" 
                    className={isActive('/privacy-policy') ? 'active' : ''}
                    onClick={handleLinkClick}
                  >
                    {t('footer.privacy')}
                  </Link>
                </div>
              </>
            ) : (
              // Mostrar solo el enlace activo en modo colapsado
              <div className="active-link-container">
                {isActive('/terms') ? 
                  <span>{t('footer.terms')}</span> :
                 isActive('/fwb') ? 
                  <span>{t('footer.fwb', 'Amigos con Beneficios')}</span> :
                 isActive('/privacy-policy') ? 
                  <span>{t('footer.privacy')}</span> :
                  <span>{t('footer.terms')}</span>
                }
                <div className="toggle-indicator">▼</div>
              </div>
            )}
          </div>
        ) : (
          // Versión horizontal normal (sin cambios)
          <>
            <div className="footer-links">
              <div className="footer-left">
                <Link to="/terms" className={isActive('/terms') ? 'active' : ''}>
                  {t('footer.terms')}
                </Link>
              </div>
              
              <div className="footer-center">
                <Link to="/fwb" className={isActive('/fwb') ? 'active' : ''}>
                  {t('footer.fwb', 'Amigos con Beneficios')}
                </Link>
              </div>
              
              <div className="footer-right">
                <Link to="/privacy-policy" className={isActive('/privacy-policy') ? 'active' : ''}>
                  {t('footer.privacy')}
                </Link>
              </div>
            </div>
            
            <div className="footer-copyright">
              <p>&copy; {currentYear} eDOP Layer 2 Solution. {t('footer.rights')}</p>
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default Footer;
